(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9118],{

/***/ 12623:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/balance",
      function () {
        return __webpack_require__(36631);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2726,3450,2198,7072,2118,4055,1456,6631,9774,2888,179], function() { return __webpack_exec__(12623); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);